<template>
  <div class="home" v-if="shop">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('ShopInfo.title')"
      left-arrow
      fixed
      :z-index="9"
      @click-left="$router.back()"
    >
    </van-nav-bar>
    <div class="content">
      <div class="card">
        <van-image
          v-if="shop.image"
          width="100%"
          fit="contain"
          :src="shop.image.path"
        />
      </div>
      <div class="card">
        <div class="shopInfo">
          <div>{{ $t("Home.shopName") }} {{ shop.name }}</div>
          <div>{{ $t("Home.address") }} {{ shop.address }}</div>
          <div>{{ $t("Home.intro") }} {{ shop.intro }}</div>
          <div>{{ $t("Home.phone") }} {{ shop.phone }}</div>
          <div>
            {{ $t("ShopInfo.time") }}：
            <template v-if="shop.after_start"
              >{{ shop.start_time }}-{{ shop.after_start }}&nbsp;&nbsp;{{
                shop.after_end
              }}-{{ shop.end_time }}</template
            ><template v-else
              >{{ shop.start_time }}-{{ shop.end_time }}</template
            >
          </div>
        </div>
      </div>
      <div class="text">
        <span>Powered by</span>
        <span class="strikethrough"></span>
      </div>
      <div class="footer">
        <img src="../../static/img/menu.png" />
        <img
          src="../../static/img/联系销售员.png"
          @click="$router.push('/ContactUs')"
        />
      </div>
      <div style="height: 80px"></div>
    </div>
    <!-- <div style="width: 100%;border-top: 1px solid #f3f3f3;padding-top:46px">
      <van-image
        v-if="shop.image"
        width="100%"
        fit="contain"
        :src="shop.image.path"
      />
    </div>
    <van-cell-group>
      <van-cell
        icon="./static/img/shopname.png"
        class="info"
        size="20px"
        :title="$t('ShopInfo.name')"
        :value="shop.name"
      />
      <van-cell
        icon="./static/img/local.png"
        class="info"
        size="20px"
        :title="$t('ShopInfo.address')"
        :value="shop.address"
      />
      <van-cell
        icon="./static/img/tele.png"
        class="info"
        size="20px"
        :title="$t('ShopInfo.phone')"
        :value="shop.phone"
      />
      <van-cell
        v-if="shop.after_start"
        icon="./static/img/Business_time.png"
        class="info"
        size="20px"
        :title="$t('ShopInfo.time')"
        :value="
          shop.start_time +
            '-' +
            shop.after_start +
            ' ' +
            shop.after_end +
            '-' +
            shop.end_time
        "
      />
      <van-cell
        v-else
        icon="./static/img/Business_time.png"
        class="info"
        size="20px"
        :title="$t('ShopInfo.time')"
        :value="shop.start_time + '-' + shop.end_time"
      />

      <van-field
        :value="shop.intro"
        type="textarea"
        autosize
        readonly
        clearable
        class="fr"
        left-icon="./static/img/introduction.png"
        :label="$t('ShopInfo.intro')"
      />
    </van-cell-group> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      shop: {}
    };
  },
  mounted: function() {
    this.getShopInfo();
  },
  methods: {
    getShopInfo() {
      // 获取门店详情
      this.$axios({
        method: "GET",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/store/" + this.$route.params.id + "/customerShow"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shop = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .fr textarea {
  text-align: right;
}
/deep/ .info,
.van-cell__value span {
  color: #000;
}
/deep/ .van-cell__value {
  color: #323233;
}
/deep/ .van-field__left-icon,
.van-cell__left-icon {
  margin-top: 4px;
}
/deep/ .card .van-image {
  width: 100%;
  height: 16.875rem;
}
.home {
  width: 100%;
  height: 100vh;
  background-color: #bbbbbb;
}
.content {
  width: 95%;
  height: 100vh;
  overflow-y: auto;
  margin: 0 auto;
  padding-top: 2.875rem;
}
.card {
  background: #fff;
  margin: 10px 5px;
  padding: 10px 20px;
  box-shadow: 0px 0px 10px #979797;
  border-radius: 5px;
}
.shopInfo div {
  margin-top: 15px;
  font-weight: 600;
}
.shopInfo div:first-child {
  margin-top: 0;
}
.text {
  display: flex;
  margin: 30px 5px 0px;
  color: #fff;
  font-weight: 600;
}
.strikethrough {
  width: calc(100% - 110px);
  border-bottom: 2px solid #fff;
  position: relative;
  top: -9px;
  margin-left: 15px;
}
.footer {
  display: flex;
  justify-content: center;
}
.footer img {
  height: 2.5rem;
  margin: 10px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ShopInfo.vue